// var base_path_giftwrap = "http://giftwrap.zestardshop.com/";
// var shop = Shopify.shop;

// if (typeof jQuery == 'undefined') {
//     setTimeout(function() {
//         var scr = document.createElement('script');
//         scr.src = base_path_giftwrap + 'js/jquery_3.2.1.js';
//         document.head.appendChild(scr);
//         scr.onload = function() {
//             $zt_jq_giftwrap = window.jQuery;
//             gift_wrap();
//         };
//     }, 300);
// } else {
//     $zt_jq_giftwrap = jQuery;
//     gift_wrap();
// }


// function gift_wrap(){
//     // var id = $('.giftwrap').attr('id');
//     var page = $('.giftwrap').attr('page');
//     $.ajax({
//             type: "GET",
//             url: base_path_giftwrap + "get_store_encrypt_id",
//             crossDomain: true,
//             data: {
//                 'shop': shop
//             },
//             success: function(id) {
//                 //console.log(data);
//                 if (id) {
//                     $.ajax({
//                         type: "GET",
//                         url: base_path_giftwrap + "preview-kosibox",
//                         crossDomain: true,
//                         data: {
//                             'id': id,
//                             'page': page
//                         },
//                         success: function(data) {
//                             //console.log(data);
//                             $(".giftwrap").html(data);
//                         }
//                     });
//                 }
//             }
//         });

    
// }


  $("#giftwrap_input").click(function (e) {
                var gift_message = $('#gift_message_note').val();
                if (gift_message == 1) {
                    $(".zt_message_note").slideToggle(this.checked);
                }
                if($(".advance_options option").length > 1){
                    $(".advance_options").slideToggle();
                }
            });
            
            var button_cart = $("[action='/cart']").find('[type="submit"]');
            
            $('#save_gift').on('click', function(e){
                e.preventDefault();
                var giftwrap_variant_id = $('#gift_wrap_variant_id').val();
                var note_msg = $('#giftwrap_text_message').val();
                var to_msg = $('#giftwrap_to_message').val();
                var from_msg = $('#giftwrap_from_message').val();
                var sku = $('.giftwrap').attr('sku');
                console.log(giftwrap_variant_id);
                $(this).prop('disabled', true);
                if ($("#giftwrap_input").is(':checked')) {
                    if ($('#giftwrap_text_message').val() == '' && $('#gift_message_note').val() == "1") {
                        alert('Legg til din hilsen');
                        $(this).prop('disabled', false);
                        return false;
                    }
                    if($(".advance_options").val() != 'default'){
                        var giftwrap_variant_id = $(".advance_options").val();
                    }



                        $.ajax({
                            url: '/cart/add.js',
                            data: {
                                'id': giftwrap_variant_id,
                                'quantity': 1,
                                'properties': {
                                    'Hilsen': note_msg,
                                    'Til'  : to_msg,
                                    'Fra': from_msg
                                }
                            },
                            async: false,
                            type: "POST",
                            cache: false,
                            complete:function(response){
                                if(response.status == "200"){
                                    window.location.href = "/cart";
                                }
                            }
                        });


                    
                }
            });
            


            $('input[name=update]').on('click', function (e) {
                var gift_wrap_variant_id = $('#gift_wrap_variant_id').attr('value');
                $(".cart__image-wrapper").each(function () {
                    var product_variant = ($(this).attr('id'));
                    if (gift_wrap_variant_id == product_variant) {
                        alert('Not allowed to add the product more then once');
                    }
                });

            });

$(document).on('click', '.cart__checkout-button', function () {
     var giftwrap_variant_id = $('#gift_wrap_variant_id').val();
                var note_msg = $('#giftwrap_text_message').val();
                var to_msg = $('#giftwrap_to_message').val();
                var from_msg = $('#giftwrap_from_message').val();
                var sku = $('.giftwrap').attr('sku');
                console.log(giftwrap_variant_id);
    // Your code here
                    if ($("#giftwrap_input").is(':checked')) {
                         if ($('#giftwrap_text_message').val() == '' && $('#gift_message_note').val() == "1") {
                        alert('Legg til din hilsen');
                        $(this).prop('disabled', false);
                             
                        return false;
                    }
                    if($(".advance_options").val() != 'default'){
                        var giftwrap_variant_id = $(".advance_options").val();
                    }
      $.ajax({
                            url: '/cart/add.js',
                            data: {
                                'id': giftwrap_variant_id,
                                'quantity': 1,
                                'properties': {
                                    'Hilsen': note_msg,
                                    'Til'  : to_msg,
                                    'Fra': from_msg
                                }
                            },
                            async: false,
                            type: "POST",
                            cache: false,
                            complete:function(response){
                                // if(response.status == "200"){
                                //     window.location.href = "/cart";
                                // }
                            }
                        });
                    }
    console.log('Checkout button clicked');
});

document.addEventListener('DOMContentLoaded', function() {
    var selectors = ['#giftwrap_text_message', '#giftwrap_to_message', '#giftwrap_from_message'];

    // Regex pattern to match allowed characters (alphanumeric, basic punctuation, and specific special characters)
    var allowedCharactersPattern = /^[a-zA-Z0-9\s.,!?'\-æøåöÆØÅÖ]*$/;

    selectors.forEach(function(selector) {
        var textArea = document.querySelector(selector);

        if (textArea) {
            textArea.addEventListener('input', function() {
                // Store the current position of the cursor
                var cursorPosition = textArea.selectionStart;

                // Remove any invalid characters
                var filteredValue = textArea.value.split('').filter(function(char) {
                    return allowedCharactersPattern.test(char);
                }).join('');

                // Update the textarea value with the filtered value
                textArea.value = filteredValue;

                // Restore the cursor position
                textArea.setSelectionRange(cursorPosition, cursorPosition);
            });
        }
    });
});
